import { Box, Button, Typography } from '@mui/material'
import InCardStack from 'components/atoms/container/InCardStack'
import { useEffect, useState } from 'react'
import { useLocation, useParams } from 'react-router-dom'
import { ASSESSMENTS, USER_PROFILE, MY_JOURNEY } from 'routes/constants'
import {
  ASSESSMENT_RECIPIENT_STATUSES,
  ASSESSMENT_QUESTIONS_OTHER_URL,
  ASSESSMENT_RECIPIENTS_URL
} from 'services/constants'
import { getRequest } from 'utils/api'
import { isUserProfileCompleted } from 'utils/userAccountHelper'
import {
  getFullName,
  capitalizeFirstLetter,
  desctructUser
} from 'utils/formatText'
import { useTranslation } from 'react-i18next'
import AssessmentCard from 'components/organisms/assessments/AssessmentCard'
import colors from 'styles/colors'
import { useNavigate } from 'react-router-dom'
import HomePage from 'components/templates/navigationPageTemplates/HomePage'
import LeftPanelTemplate from 'components/templates/LeftPanelTemplate'
import LeftPanelTitle from 'components/atoms/container/LeftPanelTitle'
import { getLocalUser } from 'utils/localStorage'
import { getGoalInfoById } from 'utils/getSupportingInfo'

const AssessmentForOthers = () => {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const params = useParams()
  const location = useLocation()
  const [firstName, ,] = desctructUser(getLocalUser())
  const [goalId, setGoalId] = useState(null)
  const [goal, setGoal] = useState(null)
  const [assessmentSenderName, setAssessmentSenderName] = useState(
    location.state?.senderName || ''
  )
  const [assessmentRecipientId, setAssessmentRecipientId] = useState(null)
  const [requestError, setRequestError] = useState(undefined)
  const [errorMessage, setErrorMessage] = useState(
    t('assessmentForOthers.notFoundAssessmentError')
  )
  const [completed, setCompleted] = useState(false)
  const userProfileCompleted = isUserProfileCompleted()
  const [questions, setQuestions] = useState([])

  const fetchData = async () => {
    const res = await getRequest(ASSESSMENT_RECIPIENTS_URL, {
      assessmentRequestId: params.assessmentRequestId
    })
    if (res.status === 200) {
      const invite = res.data.data[0]

      if (!invite || invite.status !== ASSESSMENT_RECIPIENT_STATUSES.PENDING) {
        setRequestError(true)
        if (invite?.status === ASSESSMENT_RECIPIENT_STATUSES.COMPLETED) {
          setErrorMessage(t('assessmentForOthers.youCompletedAssessmentError'))
        } else if (invite?.status === ASSESSMENT_RECIPIENT_STATUSES.REJECTED) {
          setErrorMessage(
            t('assessmentForOthers.previouslyRejectedThisRequestError')
          )
        } else if (invite?.status === ASSESSMENT_RECIPIENT_STATUSES.EXPIRED) {
          setErrorMessage(t('assessmentForOthers.assessmentExpiredError'))
        }
      } else {
        setGoalId(invite.assessmentRequest.goalId)
        const goalData = await getGoalInfoById(invite.assessmentRequest.goalId)
        setGoal(goalData)
        setAssessmentSenderName(
          capitalizeFirstLetter(getFullName(invite.assessmentRequest?.user))
        )
        setAssessmentRecipientId(invite.id)

        // Fetch other assessment questions
        const res = await getRequest(ASSESSMENT_QUESTIONS_OTHER_URL, {
          assessmentRequestId: params.assessmentRequestId
        })
        if (res.status === 200) {
          const resQuestions = res.data.data
          setQuestions(resQuestions)
        }
      }
    } else {
      setRequestError(true)
    }
  }

  useEffect(() => {
    fetchData()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const submittedCallback = () => {
    setCompleted(true)
  }

  const MessageCard = ({ title, message, children }) => {
    return (
      <Box width='100%'>
        <InCardStack spacing={12} justifyContent={'center'} height={'100%'}>
          <InCardStack spacing={6} width={450} textAlign={'center'}>
            <Typography variant='h1'>{title}</Typography>
            <Typography variant='body1Large' color={colors.Black}>
              {message}
            </Typography>
          </InCardStack>

          {children}
        </InCardStack>
      </Box>
    )
  }

  return (
    <HomePage customizedBodyWidth={true}>
      <LeftPanelTemplate
        titleGroup={
          <LeftPanelTitle
            title={t('assessmentForOthers.assessmentFor', {
              assessmentSenderName: assessmentSenderName
            })}
            superText={`Hi, ${firstName}`}
            subText={goal?.name}
          />
        }>
        {requestError ? (
          <MessageCard
            title={t('assessmentForOthers.assessmentNotAvailable')}
            message={errorMessage}>
            <InCardStack>
              <Button onClick={() => navigate(ASSESSMENTS)}>
                {t('assessmentForOthers.backToAssessments')}
              </Button>
              {userProfileCompleted === false ? (
                <Button onClick={() => navigate(USER_PROFILE)}>
                  {t('profile.finishProfile')}
                </Button>
              ) : null}
            </InCardStack>
          </MessageCard>
        ) : completed ? (
          <MessageCard
            title={t('publicRolePlay.thankYou')}
            message={t('assessmentForOthers.informationWillSignificantlyHelp', {
              assessmentSenderName
            })}>
            <Button onClick={() => navigate(MY_JOURNEY)}>
              {t('assessmentForOthers.goToMyJourney')}
            </Button>
          </MessageCard>
        ) : (
          <AssessmentCard
            goalId={goalId}
            selfAssessment={false}
            assessmentSenderName={assessmentSenderName}
            assessmentRecipientId={assessmentRecipientId}
            questions={questions}
            submittedCallback={submittedCallback}
          />
        )}
      </LeftPanelTemplate>
    </HomePage>
  )
}

export default AssessmentForOthers
